module.exports = __webpack_public_path__ + "static/media/0-goals.7fb3c7cc.png";